import Konva from "konva";
import { cloneDeep } from "lodash";
import { useEffect, useRef, useState } from "react";
import { Line, Transformer } from "react-konva";
import { Html } from "react-konva-utils";

const SimpleLine = ({
  shapeProps,
  selectedObject,
  setSelectedObject,
  addToHistory,
  currentMultipleSelection,
  setObjectScreen,
  transformerSelectedObject
}) => {
  const shapeRef = useRef<any>();
  const trRef = useRef<any>();
  const trPreSelected = useRef<any>();
  const [isSelected, setIsSelected] = useState(false);
  const [isPreSelected, setIsPreSelected] = useState(false);
  const [showRotation, setShowRotation] = useState(false);
  const [rotation, setRotation] = useState(0);

  if (shapeProps?.strokeWidth === 1) shapeProps.strokeWidth = 2;

  // ======>
  let isDraggable = shapeRef?.current?.draggable();
  //this code below verify if elements stay block and remove anchors for editions in scale
  // when element is block
  useEffect(() => {
    if (shapeRef.current) {
      isDraggable = shapeRef.current.draggable();
    }
  }, [isSelected, shapeRef]);
  // <=======

  useEffect(() => {
    if (shapeRef.current === selectedObject) {
      setIsSelected(true);
      transformerSelectedObject.current = trRef.current;
    } else {
      setIsSelected(false);
    }
  }, [selectedObject, isSelected]);

  useEffect(() => {
    trRef?.current?.setNodes([shapeRef?.current]);
    trRef?.current?.setZIndex(
      trRef?.current?.getParent()?.children?.length - 1
    );
    trRef?.current?.getLayer()?.batchDraw();
  }, [isSelected]);

  useEffect(() => {
    trPreSelected?.current?.setNodes!([shapeRef?.current]);
    trPreSelected?.current?.getLayer()?.batchDraw();
  }, [isPreSelected]);

  return (
    <>
      <Line
        ref={shapeRef}
        name="simpleLine"
        hitStrokeWidth={10}
        points={[0, 0, shapeProps?.setPoints, 0]}
        {...shapeProps}
        onClick={(event: Konva.KonvaEventObject<MouseEvent>) => {
          const isTargetInsideMultipleSelection =
            currentMultipleSelection.current?.nodes()?.includes(event.target);

          if (isTargetInsideMultipleSelection) {
            setSelectedObject(null);
          } else {
            setSelectedObject(event.target);
            currentMultipleSelection.current?.setNodes([]);
          }
        }}
        onMouseEnter={(event: Konva.KonvaEventObject<MouseEvent>) => {
          if (event.target !== selectedObject) {
            setIsPreSelected(true);
          }
        }}
        onMouseOut={(event: Konva.KonvaEventObject<MouseEvent>) => {
          setIsPreSelected(false);
        }}
        onDragStart={(event: Konva.KonvaEventObject<MouseEvent>) => {
          if (
            currentMultipleSelection.current?.nodes().length === 0 ||
            !currentMultipleSelection.current
          ) {
            addToHistory();
          }

          //if mutipleSelection includes element being dragged
          if (
            currentMultipleSelection.current?.nodes().includes(event.target)
          ) {
            setSelectedObject(null);
          } else {
            setSelectedObject(event.target);
            currentMultipleSelection.current?.setNodes([]);
          }
        }}
        onDragEnd={(event: Konva.KonvaEventObject<MouseEvent>) => {
          setSelectedObject(event.target);
          setObjectScreen(prevState => {
            let cloneState = cloneDeep(prevState);

            cloneState.forEach(page => {
              page.renderObjects.forEach(object => {
                if (object.id === event.target.id()) {
                  object.x = event.target.absolutePosition().x;
                  object.y = event.target.absolutePosition().y;
                }
              });
            });

            return cloneState;
          });
        }}
      />

      {isSelected && showRotation && (
        <Html>
          <div
            style={{
              width: "40px",
              height: "20px",
              background: "rgba(0, 0, 0, 0.8)",
              position: "absolute",
              top: shapeProps?.y - 50,
              left: Math.ceil(shapeProps?.x - 20),
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span style={{ color: "#fff" }}>{`${rotation?.toFixed(0)}°`}</span>
          </div>
        </Html>
      )}

      {isSelected && (
        <>
          <Transformer
            ref={trRef}
            keepRatio={false}
            onTransformStart={(event: Konva.KonvaEventObject<MouseEvent>) => {
              if (
                currentMultipleSelection.current?.nodes().length === 0 ||
                !currentMultipleSelection.current
              ) {
                addToHistory();
              }
            }}
            boundBoxFunc={(oldBox, newBox) => {
              if (newBox.width < 1 || newBox.height < 1) {
                return oldBox;
              }
              return newBox;
            }}
            onTransform={(event: Konva.KonvaEventObject<MouseEvent>) => {
              setShowRotation(true);
              setRotation(trRef?.current?.rotation());
              let whichTransform = trRef.current?.getActiveAnchor();
            }}
            onTransformEnd={(event: Konva.KonvaEventObject<MouseEvent>) => {
              let myWidth = trRef?.current?.width();
              let myHeight = trRef?.current?.height();
              let rotation = trRef?.current.rotation();
              setShowRotation(false);
              if (myWidth && myHeight) {
                setObjectScreen(prevState => {
                  let cloneState = cloneDeep(prevState);
                  cloneState.forEach(page => {
                    page.renderObjects.forEach(object => {
                      if (object.id === event.target.id()) {
                        object.scaleX = event.target.scaleX();
                        object.scaleY = event.target.scaleY();
                        object.x = event.target.absolutePosition().x;
                        object.y = event.target.absolutePosition().y;
                        object.rotation = rotation;
                      }
                    });
                  });
                  return cloneState;
                });
              }
            }}
          />
        </>
      )}

      {isPreSelected && (
        <Transformer
          ref={trPreSelected}
          padding={3}
          enabledAnchors={isDraggable ? [""] : []}
          onTransformStart={(event: Konva.KonvaEventObject<MouseEvent>) => {
            addToHistory();
          }}
          onClick={(event: Konva.KonvaEventObject<MouseEvent>) => {
            setSelectedObject(shapeRef.current);
          }}
          // rotateEnabled={isDraggable ? true : false}
          // resizeEnabled={isDraggable ? true : false}
          borderStroke="purple"
          rotateEnabled={false}
        />
      )}
    </>
  );
};

export default SimpleLine;
